import { type Enum } from '@webapp/infrastructure/types/Enum'

const spendingCardKey = 'spending-cards'

export const SpendingCardKeys = {
  GET_CARDS_ADMIN: [spendingCardKey, 'admin', 'cards'],
  GET_CARD_ADMIN: [spendingCardKey, 'admin', 'card'],
  GET_CARD_COUNTS_ADMIN: [spendingCardKey, 'admin', 'card-counts'],
  GET_RECONCILIATION_TRANSACTIONS: [
    spendingCardKey,
    'reconciliation-transactions',
  ],
  GET_TRANSACTIONS: [spendingCardKey, 'transactions'],
  GET_CARD_DETAILS: [spendingCardKey, 'card-details'],
  GET_CARD_PAYMENT_DETAILS: [spendingCardKey, 'card-payment-details'],
  GET_CARD_PIN: [spendingCardKey, 'card-pin'],
  GET_MY_PHYSICAL_CARD: [spendingCardKey, 'my-physical-card'],
  GET_REQUESTABLE_CARDS: [spendingCardKey, 'requestable-cards'],
  GET_TRANSACTIONS_ELIGIBLE_FOR_GL_POSTING_DATE_UPDATE: [
    spendingCardKey,
    'transactions-eligible-for-gl-posting-date-update',
  ],
  GET_TRANSACTIONS_ELIGIBLE_FOR_SYNC: [
    spendingCardKey,
    'transactions-eligible-for-sync',
  ],
} as const

export type SpendingCardKeysEnum = Enum<typeof SpendingCardKeys>
